<template>
  <div class="final-card-container">
    <div class="top-bar">
        <img src="@/assets/tarjetaresultado.png" alt="HP y RM" class="logo-central" />

    </div>
    <div class="tarjeta-render">
      <img
        v-if="processedImageUrl"
        ref="imagenFondo"
        :src="processedImageUrl"
        class="foto-fondo"
        alt="Foto generada"
        @load="imagenCargada = true"
      />


      
      <img class="overlay-frame" src="@/assets/pleca.png" alt="Marco decorativo" />
 

    </div>

    <div class="acciones">
      <div class="botones">

        <button class="imprimir" @click="imprimir">🖨️ Imprime</button>
        <button class="imprimir" @click="descargarOriginal">⬇️ Descargar Orig</button>
      </div>
      <div class="qr-section" ref="qrWrapper">
        <qrcode-vue
          v-if="qrSize"
          :value="`https://hpinfo.online/check-result/${tokenFinal}`"
          :size="qrSize"
          level="H"
        />
      </div>

    </div>
    <button class="btn-finalizar" @click="finalizar">Finalizar</button>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue'
import { useStore } from 'vuex'

import QrcodeVue from 'qrcode.vue'
import tarjetaBase from '@/assets/tarjeta_en_banco.png'
import html2canvas from 'html2canvas'
// const datos = ref({})
const processedImageName = ref('')

const qrWrapper = ref(null)
const qrSize = ref(0)

const imagenFondo = ref(null)
const imagenCargada = ref(false)

const store = useStore()
const tokenFinal = ref(store.state.tokens.tokenFinal || '')


const processedImageUrl = ref(tarjetaBase) // fallback

onMounted(() => {
 
  processedImageName.value = localStorage.getItem('processedImageName') || ''
  tokenFinal.value = store.state.tokens.tokenFinal || ''




  if (processedImageName.value) {
    processedImageUrl.value = `/img/imagenes_modificadas/${processedImageName.value}`
  }
  nextTick(() => {
    if (qrWrapper.value) {
      const anchoContenedor = qrWrapper.value.offsetWidth
      qrSize.value = Math.floor(anchoContenedor * 0.9)
    }
  })

  setTimeout(() => {
    enviarImagenCompilada()
  }, 800)
})

const descargarOriginal = () => {
  if (!processedImageName.value) {
    alert('No se encontró la imagen original.');
    return;
  }

  const link = document.createElement('a')
  link.href = `/img/imagenes_modificadas/${processedImageName.value}`
  link.download = processedImageName.value
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}


const imprimir = async () => {
  if (!imagenCargada.value) {
    alert('Espera a que cargue la imagen')
    return
  }

  await nextTick() // asegura que todo esté montado

  const tarjeta = document.querySelector('.tarjeta-render')
  if (!tarjeta) return

  const canvas = await html2canvas(tarjeta, {
    scale: 2,
    useCORS: true,
    backgroundColor: null
  })

  const link = document.createElement('a')
  link.href = canvas.toDataURL('image/png')
  link.download = 'tarjeta_final.png'
  link.click()
} 

const finalizar = () => window.location.href = '/gracias' // O ruta deseada

const enviarImagenCompilada = async () => {
  await nextTick()
  const tarjeta = document.querySelector('.tarjeta-render')
  if (!tarjeta) return

  const canvas = await html2canvas(tarjeta, {
    scale: 2,
    useCORS: true,
    backgroundColor: null,
  })

  const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/png'))
  const formData = new FormData()
  formData.append('imagen', blob, 'tarjeta_final.png')
  formData.append('clave_final', tokenFinal.value)
  formData.append('tipo', 'imagen')
  formData.append('token_premio', 'NANANA')
  formData.append('autorizado', '1')

  try {
    const response = await fetch('https://hpinfo.online/api/guardar-imagen-clave', {
      method: 'POST',
      body: formData,
    })

    const data = await response.json()
    console.log('Imagen enviada:', data)
  } catch (err) {
    console.error('Error al enviar imagen:', err)
  }
}


</script>

<style scoped lang="scss">
.overlay-frame {
    position: absolute;
    top: auto;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 100%;
    // height: 100%;
    pointer-events: none; // evita que bloquee los clics
    z-index: 5;
  }

.final-card-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(to right, #48465c 0%, #211f2e 50%, #151d2b 100%);
  min-height: 100vh;
  color: white;
  font-family: 'FormaDJRDisplay', sans-serif;
  padding: 2vh 4vw; 
  width: 100%;
  flex-direction: row;
  justify-content: space-evenly;
}

.tarjeta-render {
  position: absolute;
  width: 60vw;
  top: 27vh;
  left: 0;
  right: 0;
  bottom: auto;
  margin: auto;
  aspect-ratio: 624 / 837; /* Relación áurea */
  background: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.foto-fondo {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.datos-superpuestos {
  position: absolute;
  top: 0;
  left: 0;
  padding: 1.5rem;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  color: #1a1a1a;
}

.nombre {
  font-size: 1.5rem;
  font-weight: 500;
}
.apellido {
  font-size: 2rem;
  line-height: 1;
  font-weight: bold;
}
.numero {
  font-size: 2.4rem;
}
.posicion {
  font-size: 1.2rem;
  margin-top: 0.5rem;
}

.barra {
  margin-top: 0.2rem;
}
.barra label {
  font-size: 0.9rem;
}
progress {
  width: 100%;
  height: 8px;
  border-radius: 4px;
  overflow: hidden;
}
progress::-webkit-progress-value {
  background: #3f51b5;
}
progress::-webkit-progress-bar {
  background: #eee;
}

.acciones {
  text-align: center;
  position: absolute;
  bottom: 8vh;
  left: 0;
  right: 0;
  top: auto;
  margin: auto;
  max-width: 60vw;
  justify-content: space-between;
  align-items: center;
  display: flex;
    flex-direction: row-reverse;
  .botones {
    display: flex;
    flex-direction: column;
  }
}
.acciones button {
  margin: 1vw;
  padding: 1vw 1vw;
  font-size: 2vw;
  width: 25vw;
  // background: white;
  border: none;
  color: #fff;
  border-top: 1px solid #fff;
  border-bottom: 1px solid #fff;
  letter-spacing: 2px;
  // color: #0095d9;
  // border-radius: 5px;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    background: #fff;
    color: #000;

  }
}
.qr-section {
  // margin: 1rem auto;
  // padding: 1rem;
  background: #fff;
  width: 20vw;
  canvas {
    width: 100%!important;
  }
}
.qr-section {
  padding: 1.5%;
  background: #fff;
  width: 20vw;
  // max-width: 100%;
}


.tarjeta-preview {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
  display: flex;
  justify-content: space-between;
  padding: 1rem 1.2rem;
  box-sizing: border-box;
  pointer-events: none;
  font-family: 'FormaDJRDisplay', sans-serif;
  color: #1a1a1a;
}

.info-izquierda {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  font-weight: bold;
  font-size: 1rem;
  text-align: left;

  .nombre {
    font-size: 1.5rem;
    font-weight: 500;
    min-height: 36px;
  }

  .apellido {
    font-size: 2rem;
    min-height: 48px;
  }
  
  .numero {
    font-size: 2.4rem;
    line-height: 1.2;
    min-height: 46px;
  }
}

.info-derecha {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  font-weight: bold;
  text-align: right;

  .posicion {
    font-size: 1.1rem;
    margin-bottom: 0.5rem;
  }

  .barra {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    font-size: 0.8rem;
    // margin-bottom: 0.3rem;

    label {
      margin-bottom: 0.2rem;
    }

    progress {
      width: 120px;
      height: 8px;
      border-radius: 4px;
      overflow: hidden;
      background: #eee;

      &::-webkit-progress-bar {
        background-color: #eee;
        border-radius: 4px;
      }

      &::-webkit-progress-value {
        background-color: #3f51b5;
        border-radius: 4px;
      }

      &::-moz-progress-bar {
        background-color: #3f51b5;
      }
    }
  }
}

.barra-externa {
  width: 120px;
  height: 8px;
  background-color: #eee;
  border-radius: 4px;
  overflow: hidden;
}

.barra-interna {
  height: 100%;
  background-color: #3f51b5;
  transition: width 0.3s ease;
}
.imprimir {

}
.btn-finalizar {
  position: absolute;
  bottom: 5vw;
  right: 5vw;
  letter-spacing: 2px;
  font-size: 2em;
  display: block;
  padding: 0.3rem 1rem;
  transition: all 0.2s;
  &:hover{ 
    background: #fff;
    color: #000;
  }
}

.acciones button:nth-child(2) {
  background-color: #444;
  color: #fff;

  &:hover {
    background-color: #fff;
    color: #444;
  }
}
.top-bar {
  display: flex;
  position: absolute;
  top: 0;
  // justify-content: space-between;
  // align-items: flex-start;
  // padding: 2rem 0 1rem 0;
  color: white;

}

</style>
